module.exports = __webpack_public_path__ + "media/images/lp/fig_guide_02-9037556f103e9debf3fd495ffa0f5ba7.png";